import { useMemo } from "react";
import { createMemoryRouter, RouterProvider } from "react-router-dom";
import { StoreApi, UseBoundStore } from "zustand";

import routes from "./app/routes";
import { PackageContext } from "./quote/context/PackageContext";
import { createRoomsFromPax } from "./quote/store/rooms/createRoomsState";
import { Room } from "./quote/store/rooms/types";
import { useQuoteStore } from "./quote/store/useQuoteStore";

interface Props {
  packageId: number;
  groupSize?: number;
  arrivalDate?: string;
  drawerId: string;
}

interface InitState {
  rooms: Room[];
}

const useBindParamsInitStore = <T extends InitState>(
  store: UseBoundStore<StoreApi<T>>,
  params: Pick<Props, "groupSize">,
) => {
  const { groupSize } = params;

  if (groupSize) {
    store.setState((state) => ({
      ...state,
      rooms: createRoomsFromPax(groupSize),
    }));
  }
};

const App = ({ packageId, groupSize, arrivalDate, drawerId }: Props) => {
  const packageContext = {
    packageId,
    groupSize,
    arrivalDate,
    drawerId,
  };
  const router = useMemo(() => createMemoryRouter(routes), []);

  useBindParamsInitStore(useQuoteStore, { groupSize });

  return (
    <PackageContext.Provider value={packageContext}>
      <RouterProvider router={router} />
    </PackageContext.Provider>
  );
};

export default App;
